<template>
    <div class="px-5 pt-3">
        <h3 class="text-center mb-3"> {{ $t('pForm.createNew') }} </h3>
        <b-form v-on:submit.prevent="createProject">
            
            <b-row class="mb-2">
                <b-col sm="auto" lg="2">
                    <label for="levelid">{{ $t('comboChooseText') }}</label>
                    <select
                        @change="checkLevel()" 
                        required id="levelId" class="form-control" v-model="projectForm.levelId">
                        <option :value=0>{{ $t('comboChooseText') }}</option>

                        <option v-for="(l,li) in levels" :value=l.levelId :key="li">{{ $i18n.locale()=='kz' ? l.levelName : l.levelNameRu }}</option>
                    </select>
                </b-col>
                <b-col sm="auto" lg="2">
                    <label for="pPrice">{{ $t('pForm.pKm') }}</label>
                    <b-form-input type="number" required  id="pKm" class="form-control" v-model.number="projectForm.pKm"/>
                </b-col>
                <b-col sm="auto" lg="2">
                    <label for="pPrice">{{ $t('pForm.pPrice') }}</label>
                    <b-form-input type="number" required  id="pPrice" class="form-control" v-model.number="projectForm.pPrice"/>
                </b-col>
                <b-col sm="auto" lg="6">
                    <label for="pAddress">{{ $t('pForm.pAddress') }}</label>
                    <textarea  required   id="pAddress" class="form-control" v-model="projectForm.pAddress"></textarea>
                </b-col>
            </b-row>

            <b-row class="mb-2">
                <b-col sm="auto" lg="6">
                    <label for="locationId">{{ $t('comboChooseText') }}</label>
                    <select
                        required id="locationId" class="form-control" v-model="projectForm.locationId">
                        <option :value=0>{{ $t('comboChooseText') }}</option>
                        <option v-for="(l,li) in locations" :value=l.locationId :key="li">
                            {{ $i18n.locale()=='kz' ? l.locationName : l.locationNameRu }}
                        </option>
                    </select>
                </b-col>
                <b-col sm="auto" lg="6">
                    <label for="organizations">{{ $t('pForm.organizations') }}</label>
                    <multiselect 
                        v-model="projectForm.orgs" 
                        :options="organizations"
                        :multiple="true"
                        track-by="orgName"
                        :custom-label="customLabel"
                        >
                    </multiselect>
                </b-col>
            </b-row>

            <b-row class="mb-2">
                
                <b-col sm="auto" lg="3">
                    <label for="pPrice">{{ $t('pForm.pNumber') }}</label>
                    <input  required  id="pPrice" class="form-control" v-model="projectForm.pNumber"/>
                </b-col>
                <b-col sm="auto" lg="3">
                    <label for="pName">{{ $t('pForm.pName') }}</label>
                    <input  required  id="pName" class="form-control" v-model="projectForm.pName"/>
                </b-col>
                <b-col sm="auto" lg="3">
                    <label for="pDate">{{ $t('pForm.pDate') }}</label>
                    <input class="form-control" id="pDate" v-model="projectForm.pDate" type="date">
                </b-col>
                <b-col sm="auto" lg="3">
                    <label for="endDate">{{ $t('pForm.endDate') }}</label>
                    <input class="form-control" id="endDate" v-model="projectForm.endDate" type="date">
                </b-col>
            </b-row>
            <b-row class="mb-2" v-if="levelCode=='sr'">
                <b-col sm="auto" lg="4">
                    <label for="pTopCover">{{ $t('pForm.pTopCover') }}</label>
                    <input  required type="number"  id="pTopCover" class="form-control" v-model.number="projectForm.pTopCover"/>
                </b-col>
                <b-col sm="auto" lg="4">
                    <label for="pBottomCover">{{ $t('pForm.pBottomCover') }}</label>
                    <input  required type="number"  id="pBottomCover" class="form-control" v-model.number="projectForm.pBottomCover"/>
                </b-col>
                <b-col sm="auto" lg="4">
                    <label for="pMainCover">{{ $t('pForm.pMainCover') }}</label>
                    <input  required type="number"  id="pMainCover" class="form-control" v-model.number="projectForm.pMainCover"/>
                </b-col>
            </b-row>
                
            <b-form-row class="mb-3">
                <b-row class="pt-2 text-right">
                    <b-col lg="12" class="text-right">
                        <b-button size="sm" variant="primary" class="mr-2" type="submit">{{$t("lms.add")}}</b-button>
                        <b-button size="sm" variant="danger" @click="clearForm">{{$t("lms.clear")}}</b-button>
                    </b-col>
                </b-row>
            </b-form-row>
        </b-form>
    </div>
</template>
<script>
import axios from 'axios';
import {apiDomain,getHeader} from "@/config/config";
import vue from 'vue';
import Multiselect from 'vue-multiselect'
import  'vue-multiselect/dist/vue-multiselect.min.css';
export default{
    name:"ProjectForm",
    props:["sysChange"],
    components: { Multiselect },
    data(){
        return {
            projectForm:{
                pId:0,
                pName:"",
                pNumber:"",
                pAddress:"",
                pKm:0,
                pPrice:0,
                usedPrice:0,
                
                usedPrice:0,
                pDate:"",
                endDate:"",
                pTopCover:0,
                pBottomCover:0,
                pMainCover:0,
                levelId:0,
                locationId:0,
                orgs:[]
            },

            levelCode:"",
            levels:[],
            locations:[],
            organizations:[]   
        }
    },
    methods: {
        customLabel (option) {
            return `${option.orgName} - ${option.bin}`
        },
        checkLevel(){
           let code =  this.levels.filter(l=>Number(l.levelId)==Number(this.projectForm.levelId))[0].code;
            if(code=='sr'){
                this.levelCode = "sr";
            }else{
                this.levelCode="";
            }
        },
        updateCategory(catId){
            axios.post(apiDomain+'/oyu/cat/current',{catId:catId},{headers:getHeader()})
            .then(response=>{
                this.catForm=response.data;
                this.$bvModal.show('oyuCatModal')    
            })
            .catch(error => {
                //console.log(error.message)
                this.$bvToast.toast(error.message, {
                    title: 'алдаа',
                    autoHideDelay: 5000
                })
            }) 
        },
        createProject(){
            
            //alert(JSON.stringify(this.projectForm.orgs));
            axios.post(apiDomain+'/p/create',this.projectForm,{headers:getHeader()})
            .then(response=>{
                if(response.data=='success'){
                    this.clearForm();
                    //this.sysChange();
                    this.$bvToast.toast(vue.i18n.translate("system.successMsg"), {
                        variant:"success",
                        title: vue.i18n.translate("system.successTitle"),
                        autoHideDelay: 5000
                    })
                }
            })
            .catch(error => {
                alert(error.message);
            })        
        },
        clearForm(){
            this.projectForm={
                pId:0,
                pName:"",
                pNumber:"",
                pAddress:"",
                pKm:0,
                pPrice:0,
                usedPrice:0,
                
                usedPrice:0,
                pDate:"",
                endDate:"",
                pTopCover:0,
                pBottomCover:0,
                pMainCover:0,
                levelId:0,
                levelId:0,
                locationId:0,
                orgs:[]
            }   
        },
        projectLevels(){
            axios.post(apiDomain+'/p/listlevel',{},{headers:getHeader()})
            .then(response=>{
                this.levels=response.data;
            })
            .catch(error => {
                alert(error.message);
            })     
        },
        listLocation(){
            axios.post(apiDomain+'/p/listlocation',{},{headers:getHeader()})
            .then(response=>{
                this.locations=response.data;
            })
            .catch(error => {
                alert(error.message);
            })     
        },
        listOrganization(){
            
            axios.post(apiDomain+'/p/listorganization',{},{headers:getHeader()})
            .then(response=>{
                this.organizations=response.data;
                //alert(JSON.stringify(this.organizations));
            })
            .catch(error => {
                alert(error.message);
            })
        }
    },
    created(){
        this.projectLevels();
        this.listLocation();
        this.listOrganization();
    }    
}
</script>
